export default __webpack_public_path__ + "static/media/mha_logo.11e0f9fb.jpg";